import AircraftProperty from "./AircraftProperty";

// This maps data key-values from Spire responses to `VesselProperty`s
const AircraftSpireDataPropertyMap = {
	[AircraftProperty.STATE]: "event",
	[AircraftProperty.FLIGHT_NUMBER]: "flight_number",
	[AircraftProperty.FLIGHT_OPERATOR]: "airline_name",
	[AircraftProperty.EQUIPMENT]: "equipment",
	[AircraftProperty.REGISTRATION]: "aircraft_type_icao",
	[AircraftProperty.ALTITUDE]: "altitude_gnss",
	[AircraftProperty.ALTITUDE_BARO]: "altitude_baro",
	[AircraftProperty.CALL_SIGN]: "callsign",
	[AircraftProperty.DESTINATION_IATA]: "arrival_airport_iata",
	[AircraftProperty.DESTINATION_ICAO]: "arrival_airport_icao",
	[AircraftProperty.ORIGIN_IATA]: "departure_airport_iata",
	[AircraftProperty.ORIGIN_ICAO]: "departure_airport_icao",
	[AircraftProperty.TIMESTAMP]: "timestamp",
	[AircraftProperty.ICAO_ADDRESS]: "icao_address",
	[AircraftProperty.SIL]: "sil",
	[AircraftProperty.NAC_P]: "nacp",
	speed: "speed",
	heading: "heading",
	course: "heading"
};
export default AircraftSpireDataPropertyMap;
